import React, { Component } from 'react';
import $ from "jquery";
import TopMenu from '../commonFiles/TopMenu';
import Spinner from '../commonFiles/Spinner';
import Footer from '../commonFiles/Footer';
import Banner from './Banner';
import AboutInfo from './AboutInfo';
import MissionVision from './MissionVision';
import ValueSystem from './ValueSystem';
import OurStory from './OurStory';
import AwardsAndRankings from './AwardsAndRankings';
import WhatWeDoInfo from './WhatWeDoInfo';
import Careers from './Careers';
class AboutUs extends Component {
  constructor() {
    super();
    this.state = {
    };
  }

componentDidMount(){
  $("html, body").animate({ scrollTop: 0 });
  window.menu_selection('/aboutus');
}


  render() {
    return (
        <div className="container-xxl page_background p-0">
          <Spinner/>
          <TopMenu title="About Us"/>
          <AboutInfo/>
          <OurStory/>
          <WhatWeDoInfo/>
          <MissionVision/>
          <AwardsAndRankings/>
          {/*<Careers/>*/}
          <Footer />
        </div>
    );
  }
}

export default AboutUs;
